// AI features are on for every deployment (2026-10-01 decision). Each REACT_APP_* flag is only a kill switch:
// ON unless set to 'false'. Every frontend flag check reads these constants (re-exported by the API modules).
// Pure: no API/axios imports.

export const isFlagOn = (raw: string | undefined): boolean => (raw ?? '').trim().toLowerCase() !== 'false'

export const SCRIBE_ENABLED = isFlagOn(process.env.REACT_APP_SCRIBE_ENABLED)
export const PATIENT_SUMMARY_ENABLED = isFlagOn(process.env.REACT_APP_PATIENT_SUMMARY_ENABLED)
export const DISCHARGE_SUMMARY_AI_ENABLED = isFlagOn(process.env.REACT_APP_DISCHARGE_SUMMARY_AI_ENABLED)
